import React from 'react'
import {Col, DatePicker, Form, Input} from 'antd'
import {get} from 'lodash'
import {dateVal} from '../../../../modules/Utils'

const {TextArea} = Input

function VendorForm(props) {
  const {getFieldDecorator} = props.form
  const formItemLayout = {
    labelCol: {
      xs: {span: 24},
      sm: {span: 6},
    },
    wrapperCol: {
      xs: {span: 24},
      sm: {span: 14, offset: 1},
    },
  }
  const {vendor} = props

  return (
    <Form>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Name">
          {getFieldDecorator('name', {
            initialValue: get(vendor, 'name'),
          })(<Input />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Details">
          {getFieldDecorator('details', {
            initialValue: get(vendor, 'details'),
          })(<TextArea />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Start date">
          {getFieldDecorator('date.start', {
            initialValue: dateVal(vendor, 'date.start'),
          })(<DatePicker style={{width: '100%'}} />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="End date">
          {getFieldDecorator('date.end', {
            initialValue: dateVal(vendor, 'date.end'),
          })(<DatePicker style={{width: '100%'}} />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Reference No">
          {getFieldDecorator('reference.no', {
            initialValue: get(vendor, 'reference.no'),
          })(<Input />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Tax No">
          {getFieldDecorator('tax.no', {
            initialValue: get(vendor, 'tax.no'),
          })(<Input />)}
        </Form.Item>
      </Col>
    </Form>
  )
}

VendorForm.propTypes = {}
VendorForm.defaultProps = {}

export default Form.create()((VendorForm))
